<div class="gc-dg-payment-summary gc-dg-mt-5">
    <p class="gc-dg-text-2xl gc-dg-mt-0">When will my plan start?</p>
    <p>
        Please refer to the coverage effective date, which is stated on your plan documentation. Your coverage will start then, on condition of the timely payment of the plan fee.
    </p>
    <p>
        For products still covered by an extended warranty, the plan will start when that warranty ends
    </p>
    <p>
        If an extended warranty expired under 60 days ago, the plan will start immediately. Or if it expired more than 60 days ago, the plan will start after a 30-day wait period.
    </p>
</div>